import React from "react";
import Button from "../../common/button";
import { useWeb3Modal } from "@web3modal/react";

export const ConnectButton = (props) => {
  const { open } = useWeb3Modal();

  return (
    <Button lg {...props} variant="mint" onClick={open} className="btn-mint">
      Connect Wallet
    </Button>
  );
};
